import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { MoreCircle } from './more';

export const NavLinkStyles = css`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  height: 50px;
  padding: 0.25rem 0;
  font-size: 0.75rem;
  font-family: ${Styles.fontFamily.base};
  letter-spacing: 0.3px;
  line-height: 0;
  text-decoration: none;
  color: ${Styles.color.mobileNavButtonColor};
  fill: ${Styles.color.mobileNavButtonColor};

  &.active {
    color: ${Styles.color.primary};
    fill: ${Styles.color.primary};
  }
  &.active ${MoreCircle} {
    background-color: ${Styles.color.secondary};
  }
`;

const StyledLink = styled(Link)`
  ${NavLinkStyles};
`;

export const NavButton = styled.button`
  ${NavLinkStyles}
`;

export default StyledLink;
